import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Sentry from '@sentry/angular';
import { RecaptchaComponent } from 'ng-recaptcha';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import 'hammerjs';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.sentry.dns,
  environment: environment.environment,
  normalizeDepth: 5,
  ignoreErrors: [
    'Illegal invocation',
    /Cannot read property 'loaded' of undefined/,
    /Can't find variable: fbq/,
    'fbq is not defined',
    '@safari-extension',
    'InvalidAccessError: The object does not support the operation or argument.',
    'Block-scoped declarations (let, const, function, class) not yet supported outside strict mode',
    /Failed to execute 'sendBeacon' on 'Navigator'/,
    'Non-Error promise rejection captured',
  ],
  beforeSend(event) {
    if (
      !environment.sentry.enabled ||
      window.location.href.includes('localhost')
    ) {
      // Console error message when developing
      console.error(event.message, event.extra);
      return null;
    }
    return event;
  },
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

// temporary fix, check if needed when updating recaptcha to next version
// https://github.com/DethAriel/ng-recaptcha/issues/123#issuecomment-426112101
RecaptchaComponent.prototype.ngOnDestroy = function () {
  if (this.subscription) {
    this.subscription.unsubscribe();
  }
};
